<div id="content">
  <button [hidden] = '!tagMarked()' class = "openbutton" (click) = "openTag()" i18n="@@maps.open">Otwórz</button>
  <button [hidden] = '!saveAvailable()' class = "savebutton" (click) = "saveData()" i18n="@@maps.save">Zapisz</button>
  <div id="contentMap" [style.marginTop.px] = '(saveAvailable() || tagMarked()) ? 0 : 40'>
    <div class = "columnMap">
      <h1 i18n="@@maps.Map" >Mapa</h1>
      <div id="mapContainer">
        <img [src]="getMap()" (click)="mapClicked($event)" width="100%" height="100%"  >
        <div *ngFor = "let item of items">
          <img id="positioner" src="/assets/loc.png" height="5%"
          (load) ="posLoaded($event.target,item.ID)"
          (mouseenter)="posHover($event.target, item.ID)"
          (mouseleave)="posUnhover($event.target)"
          (click)="itemClicked(item.ID)" [ngStyle]="{'left': item.X-2 + '%', 'top': item.Y-3 + '%' }">
        </div>
      </div>
      <br>
      <div id="itemDescription" *ngIf="descv" >
        <h2 i18n="@@maps.lastEntry">Ostatni wpis: </h2>
        <h3>{{currentLastEntry | date: 'medium'}} {{currentPerson}}</h3>
        <br>
        <h2 i18n="@@maps.state">Stan: </h2>
        <h3>{{currentState}}</h3><br>
        <h2 i18n="@@maps.category">Kategoria: </h2>
        <h3>{{currentCategory}}</h3><br>
        <h2 i18n="@@maps.size">Rozmiar: </h2>
        <h3>{{currentSize}}</h3><br>
        <div [hidden] = '!tagMarked()' >
          <h4 i18n="@@maps.newPosition">Kliknij na mapie aby zaznaczyć nową pozycję znacznika</h4>
        </div>
      </div>

    </div>

    <div class = "columnData">
      <div class="selectContainer">
        <mat-form-field>
          <mat-label class="mapSelectorTitle" i18n="@@maps.chooseWarehouse">Wybierz magazyn</mat-label>
          <mat-select class="mapSelector"  [(ngModel)]="selectedLocation" (selectionChange)="locationChanged($event.value)">
            <mat-option class="selectMapOpt" *ngFor="let loc of locations | keyvalue" [value]="loc.value.NAME">{{loc.value.NAME}}</mat-option>
          </mat-select >
        </mat-form-field>
      </div>
      <div class = "lineDiv">
        <th id="tableDesc" [hidden]="getType() === 'commercial'" i18n="@@maps.desc">Opis</th>
        <th id="tableDesc" [hidden]="getType() !== 'commercial'" i18n="@@maps.name">Nazwa</th>

        <h2 id="tableID">ID</h2>
      </div>
      <div id="mapList" style="overflow-x:auto; height: 75%;">
        <table style="width:100%; ">
            <tbody>
              <tr (mouseenter)="itemListHover(item.ID)" (mouseleave)="itemListUnhover(item.ID)" id="itemsTable" *ngFor = "let item of items" (click)="itemClicked(item.ID)">
                <td [hidden]="getType() === 'commercial'">{{item.Desription}}</td>
                <td [hidden]="getType() !== 'commercial'">{{item.Title}}</td>
                <td>{{item.ID}}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</div>
